(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('ProfileDetailController', ProfileDetailController);

    ProfileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Profile', 'User', 'SkipperLevelHolder'];

    function ProfileDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Profile, User, SkipperLevelHolder) {
        var vm = this;

        vm.profile = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('askApp:profileUpdate', function(event, result) {
            vm.profile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
